export default {
      id: "cellphone-usage",
      viewBox: "0 0 22 38",
      url: "/dist/svg/" + "sprite.svg#cellphone-usage",
      toString: function () {
        return this.url;
      }
    }